module.exports = __webpack_public_path__ + "img/Cloud_5.3075150f.png";